import { useEffect, useState } from 'react'
import useI18n from './use_i18n'
export default function useUserHref() {
  const [userHref, setUserHref] = useState({
    login: '',
    register: '',
    buyer: '',
    api: ''
  })
  const { activeLocale } = useI18n()
  useEffect(() => {
    let origin = window?.location.origin
    origin = origin.includes('localhost') ? 'https://test-www-1.17track.net' : origin
    const hrefMap = {
      login: `${origin.replace('www', 'user')}/en`,
      register: `${origin.replace('www', 'user')}/en/register`,
      buyer: `${origin.replace('www', 'admin')}/buyer`,
      api: `${origin.replace('www', 'admin')}/api`
    }
    setUserHref({
      login: hrefMap.login.replace('en', activeLocale),
      register: hrefMap.register.replace('en', activeLocale),
      buyer: hrefMap.buyer,
      api: hrefMap.api
    })
  }, [])
  return userHref
}
